import Crud from '../views/Team/Crud'
import Entity from '../views/Team/Add'

let routes = {
    path: '/teams',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/teams/add',
            name: 'NewTeam',
            component: Entity,
            meta: {
                pageTitle: 'Equipes',
                breadcrumb: [{ text: 'Adicionar Equipe', active: true }],
            },
        },
        {
            path: '/teams/edit/:id?',
            name: 'EditTeam',
            component: Entity,
            meta: {
                pageTitle: 'Equipes',
                breadcrumb: [{ text: 'Editar Equipe', active: true }],
            },
        },
        {
            path: '/teams',
            name: 'list-teams',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Equipes',
                breadcrumb: [{ text: 'Equipes', active: true }],
            },
        },
    ]
};

export default routes
